import React from 'react'
import { Typography } from '@ann/web-components'
import { SharedWithMeContainer, SharedWithMeContent } from './SharedWithMePage.styled'

const SharedWithMePage = () => {
    return (
        <SharedWithMeContainer>
            <SharedWithMeContent>
	            Contenido de Shared With Me
            </SharedWithMeContent>
        </SharedWithMeContainer>
    )
}

export default SharedWithMePage
